<template>
  <div class="modal" tabindex="-1" role="dialog" v-if="isVisible">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">未実施取消確認</h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-body">
          <p class="mb-0">未実施を取り消します。よろしいですか？</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">キャンセル</button>
          <button type="button" class="btn btn-primary" @click="registerWorkUnworkedCancel">
            取消
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { workUnworkedCancel } from '@/api/axios';

export default {
  emits: ['onClose'],
  setup(_, { emit }) {
    const store = useStore();
    const router = useRouter();
    const isVisible = ref(false);
    const temporaryWorkData = reactive({
      id: null,
      year: null,
      month: null,
    });

    const show = ({ temporaryWorkId, year, month }) => {
      temporaryWorkData.id = temporaryWorkId;
      temporaryWorkData.year = year;
      temporaryWorkData.month = month;
      isVisible.value = true;
    };

    const closeModal = () => {
      isVisible.value = false;
    };

    const registerWorkUnworkedCancel = async () => {
      try {
        await workUnworkedCancel(temporaryWorkData.id);
        store.dispatch('setFlashMessage', { message: '未実施取消完了！', type: 'success' });
        const path = '/temporary-works';

        router.push({
          path,
          query: { year: temporaryWorkData.year, month: temporaryWorkData.month },
        });
        closeModal();
        emit('onClose');
      } catch (error) {
        console.error('未実施取消エラー:', error);
      }
    };

    return {
      isVisible,
      show,
      closeModal,
      registerWorkUnworkedCancel,
    };
  },
};
</script>

<style scoped>
.modal {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-dialog {
  max-width: 500px;
}
</style>
